function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Version-2.1---User-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wizard---Log-Out",
  transform: "translate(-429.000000, -607.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(430.000000, 608.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 16.625000)",
  fill: "#00AEFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "dead-hand",
  transform: "translate(55.274656, 46.586009) rotate(90.000000) translate(-55.274656, -46.586009) translate(8.774656, -8.413991)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M92.1948539,109.375 L92.1948539,7.67663043 C92.1948539,3.47825807 89.4010793,0.679347826 85.2104103,0.679347826 L36.3193054,0.679347826 C32.1286365,0.679347826 29.3348619,3.47825807 29.3348619,7.67663043 L29.3348619,24.7078776 L9.25869947,25 C-2.55963303,24.7078776 -2.55963303,47.6774383 9.25869947,47.6774383 L29.3348619,47.6774383 L29.3348619,95.3804348",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 50.2881925,
  y1: 24.4157609,
  x2: 50.2881925,
  y2: 2.41576087,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 71.2415232,
  y1: 24.4157609,
  x2: 71.2415232,
  y2: 2.41576087,
  id: "Path"
}))), /*#__PURE__*/React.createElement("g", {
  id: "tap-02",
  transform: "translate(149.040138, 75.417431) rotate(90.000000) translate(-149.040138, -75.417431) translate(74.540138, 53.417431)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("line", {
  x1: 73.3027523,
  y1: 0,
  x2: 73.3027523,
  y2: 18.75,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 148.165138,
  y1: 29.6875,
  x2: 134.12844,
  y2: 43.75,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 29.6875,
  x2: 14.0366972,
  y2: 43.75,
  id: "Path"
})))));

var SvgThankyouIcon = function SvgThankyouIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "174px",
    height: "152px",
    viewBox: "0 0 174 152",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThankyouIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thankyouIcon.e95cd5c3.svg";
export { ForwardRef as ReactComponent };